import { render, staticRenderFns } from "./sluserteam-add-or-update.vue?vue&type=template&id=189ba8b9&"
import script from "./sluserteam-add-or-update.vue?vue&type=script&lang=js&"
export * from "./sluserteam-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports